import { RouteRecordRaw } from 'vue-router'

import _404 from '@desktop/views/404.vue'
import Demo from '@desktop/views/Demo.vue'
import Empty from '@desktop/views/Empty.vue'
import Home from '@desktop/views/Home.vue'
import Relation from '@desktop/views/Relation/Relation.vue'

import { Route } from './consts'

const routes: RouteRecordRaw[] = [
  {
    name: Route.Home,
    path: '/',
    component: Home,
  },
  {
    name: Route.Relation,
    path: '/relation/:eventId(\\d+)/',
    component: Relation,
    children: [
      { name: Route.RelationMain, path: '', component: Empty },
      { name: Route.RelationStatistics, path: 'statistics', component: Empty },
    ],
  },
  {
    name: Route.Demo,
    path: '/demo/:eventId(\\d+)/',
    component: Demo,
  },
  {
    // no route match - fallback
    name: Route.Error404,
    path: '/:pathMatch(.*)*',
    component: _404,
  },
]

export { routes }
